import React, { useState } from "react";
import { useCopyClones } from "./useCopyClones";
import { createClone, deleteClone } from "./cloneUtils";
import CloneListView from "./CloneListView";
import CloneEditor from "./CloneEditor";
import "./CopyCloneAI.css";

const CopyCloneAI = ({ userId }) => {
  const { clones, loading } = useCopyClones(userId);
  const [activeCloneId, setActiveCloneId] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);

  const handleCreate = async () => {
    // Defaults are inlined in createEmptyClone — no need to override here.
    const created = await createClone(userId);
    setActiveCloneId(created.id);
  };

  const handleDelete = async () => {
    if (!confirmDelete) return;
    await deleteClone(userId, confirmDelete.id);
    setConfirmDelete(null);
    if (activeCloneId === confirmDelete.id) setActiveCloneId(null);
  };

  if (loading) {
    return (
      <div className="cca-root">
        <div className="cca-loading">
          <div className="cca-spinner" />
          <span>Loading CopyTwins…</span>
        </div>
      </div>
    );
  }

  return (
    <div className="cca-root">
      {activeCloneId ? (
        <CloneEditor
          userId={userId}
          cloneId={activeCloneId}
          onBack={() => setActiveCloneId(null)}
        />
      ) : (
        <CloneListView
          clones={clones}
          onOpen={(id) => setActiveCloneId(id)}
          onCreate={handleCreate}
          onDelete={(c) => setConfirmDelete(c)}
        />
      )}

      {confirmDelete && (
        <div
          className="cca-modal-backdrop"
          onClick={() => setConfirmDelete(null)}
        >
          <div className="cca-modal" onClick={(e) => e.stopPropagation()}>
            <div className="cca-modal-icon">
              <i className="fa-solid fa-triangle-exclamation" />
            </div>
            <h3>Delete this CopyTwin?</h3>
            <p>
              <strong>{confirmDelete.name || "Unnamed CopyTwin"}</strong> will be
              permanently removed. Templates that reference it will fall back
              to Normal Mode.
            </p>
            <div className="cca-modal-actions">
              <button
                type="button"
                className="cca-btn-ghost"
                onClick={() => setConfirmDelete(null)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="cca-btn-danger"
                onClick={handleDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CopyCloneAI;
